import { mode } from '@chakra-ui/theme-tools';
const Card = {
	baseStyle: (props: any) => ({
		p: '20px',
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		position: 'relative',
		borderRadius: '20px',
		minWidth: '0px',
		wordWrap: 'break-word',
		bg: mode('#ffffff', 'navy.800')(props),
		border: mode('1px solid rgba(104, 26, 45, 0.08)', '1px solid rgba(255, 255, 255, 0.08)')(props),
		boxShadow: mode('0 18px 45px rgba(74, 35, 25, 0.08)', 'unset')(props),
		backgroundClip: 'border-box'
	})
};

export const CardComponent = {
	components: {
		Card
	}
};
